import React from 'react';

import {
  Avatar,
  Typography,
  Grid,
  Divider,
  Button,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';


const activityProfile = (props) => {
  const avatarUrl = constants.BASE_URL + props.item.target_user.avatar;

  return (
    <React.Fragment>
      <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />
      <Grid container spacing={8}>
        <Grid item md={3} sm={3} xs={4} align="center" className={classes.padding10}>
          <Avatar
            src={avatarUrl}
            className={classes.activityActionAvatar}
            alt={props.item.target_user.slug}
          />
        </Grid>
        <Grid item md={9} sm={9} xs={8} className={classes.padding10}>
          <Typography variant="title">
            {props.item.target_user.first_name} {props.item.target_user.last_name}
          </Typography>
          <Typography variant="subheading">{props.item.target_user.profile_id}</Typography>
          <Typography variant="subheading">
            Last active: {props.item.target_user.last_login ? props.item.target_user.last_login : 'Never'}
          </Typography>
        </Grid>
      </Grid>
      <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />
      <Grid container spacing={16}>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Marital Status</p>
          <p className={classes.profileVal}>{props.item.target_user.marital_status}</p>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Caste</p>
          <p className={classes.profileVal}>{props.item.target_user.caste}</p>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Age</p>
          <p className={classes.profileVal}>{props.item.target_user.age}</p>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Height</p>
          <p className={classes.profileVal}>{props.item.target_user.height}</p>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Degree</p>
          <p className={classes.profileVal}>{props.item.target_user.degree}</p>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Work Profile</p>
          <p className={classes.profileVal}>{props.item.target_user.work_profile}</p>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>City</p>
          <p className={classes.profileVal}>{props.item.target_user.city}</p>
        </Grid>
        <Grid item md={12} sm={12} xs={12} align="center">
          <Button variant="outlined" color="primary" onClick={() => props.viewProfile(props.item.target_user.slug)}>
            View full profile
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default activityProfile;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityProfile.js